import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./CountryUIHelpers";

const CountryUIContext = createContext();

export function useCountryUIContext() {
  return useContext(CountryUIContext);
}

export const CountryUIConsumer = CountryUIContext.Consumer;

export function CountryUIProvider({ CountryUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openEditProductPage: CountryUIEvents?.openEditProductPage,
    openDeleteProductDialog: CountryUIEvents?.openDeleteProductDialog,
    openDeleteCountryDialog: CountryUIEvents?.openDeleteCountryDialog,
    openFetchCountryDialog: CountryUIEvents?.openFetchCountryDialog,
    openUpdateCountryStatusDialog:
      CountryUIEvents?.openUpdateCountryStatusDialog,
  };

  return (
    <CountryUIContext.Provider value={value}>
      {children}
    </CountryUIContext.Provider>
  );
}
